import {
  IoCalendarOutline,
  IoTicketOutline,
  IoCard,
  IoSettingsOutline,
  IoDocumentOutline,
  IoPersonOutline,
} from "react-icons/io5";

export type TabType = "reservations" | "tickets" | "ecard" | "settings" | "documents" | "people";

export interface TabConfig {
  id: TabType;
  desktopLabel: string;
  mobileLabel: string;
  requiresConfig?: "ecard_showCode" | "allowSubaccounts";
  icon: React.ReactNode;
}

export const TABS_CONFIG: TabConfig[] = [
  {
    id: "reservations",
    desktopLabel: "Twoje rezerwacje",
    mobileLabel: "Rezerwacje",
    icon: IoCalendarOutline,
  },
  {
    id: "tickets",
    desktopLabel: "Twoje bilety i karnety",
    mobileLabel: "Bilety/karnety",
    icon: IoTicketOutline,
  },
  {
    id: "ecard",
    desktopLabel: "Twoja eKarta",
    mobileLabel: "eKarta",
    requiresConfig: "ecard_showCode",
    icon: IoCard,
  },
  {
    id: "documents",
    desktopLabel: "Twoje dokumenty",
    mobileLabel: "Dokumenty",
    icon: IoDocumentOutline,
  },
  {
    id: "people",
    desktopLabel: "my_account_tab_people_desktop",
    mobileLabel: "my_account_tab_people_mobile",
    requiresConfig: "allowSubaccounts",
    icon: IoPersonOutline,
  },
  {
    id: "settings",
    desktopLabel: "Ustawienia konta",
    mobileLabel: "Ustawienia",
    icon: IoSettingsOutline,
  },
];
